import { render, staticRenderFns } from "./ItemCard.vue?vue&type=template&id=b61ca0aa&scoped=true&"
import script from "./ItemCard.vue?vue&type=script&lang=js&"
export * from "./ItemCard.vue?vue&type=script&lang=js&"
import style0 from "./ItemCard.vue?vue&type=style&index=0&id=b61ca0aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61ca0aa",
  null
  
)

export default component.exports